import React, { useState } from 'react';

import clsx from 'clsx';

import SvgUploadPhoto from '../../../../assets/icons/UploadPhoto';
import { ThemedButton } from '../../../../shared/components/themed-button';
import { ImageUpload } from '../../../../shared/components/image-upload';

import { useStyles } from './style';

interface Props {
  picture_url?: string;
  setProfileLogo: (file: Blob) => void;
}

export const UploadLogoField: React.FC<Props> = ({ picture_url, setProfileLogo  }) => {
  const classes = useStyles();

  const [isImageUploadShown, changeIsImageUploadShown] = useState(false);
  const [logo, setLogo] = useState<Blob | null>(null);

  const onUploadLogo = (file: Blob) => {
    setLogo(file);
    setProfileLogo(file);
    changeIsImageUploadShown(false);
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>UPLOAD YOUR LOGO</div>
      <div className={classes.subTitle}>Square Logos with a white background work best</div>
      <div className={classes.uploadBox}>
        {isImageUploadShown ? (
          <ImageUpload
            cropTitle=''
            saveImage={onUploadLogo}
            closeModal={changeIsImageUploadShown.bind(null, false)}
            skipCloseOnSave={true}
            autoOpenFileDialog={true}
          />
        ) : (
          <>
            <div className={clsx([classes.imgWrap])} onClick={changeIsImageUploadShown.bind(null, true)}>
              {picture_url || logo ? (
                <>
                  <img src={logo ? URL.createObjectURL(logo) : picture_url} alt='logo' />
                </>
              ) : (
                <div className={classes.uploadPhoto}>
                  <SvgUploadPhoto />
                </div>
              )}
            </div>
            <ThemedButton
              onClick={changeIsImageUploadShown.bind(null, true)}
              title='Upload a photo'
              buttonStyle='primary'
              customClass={classes.uploadButton}
            />
          </>
        )}
      </div>
    </div>
  );
};
